import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 7a2 2 0 0 1 1.85-1.995L5 5h6.586a2 2 0 0 1 1.284.467l.13.119L16.415 9H27a2 2 0 0 1 1.994 1.85L29 11v14.111a1.89 1.89 0 0 1-1.741 1.883L27.11 27H4.921a1.926 1.926 0 0 1-1.915-1.773L3 25.077zm24 4H5l-.001 14H27zM11.586 7H5v2h8.585z"
    />
  </svg>
);
const SvgIconFolder = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFolder);
export default Memo;
